<div class="td-flip" [ngClass]="{'flipped': view === 'development'}">
  <div class="td-flip-inner">
    <div class="td-flip-face td-flip-front">
      <app-pyramid [categories]="categories"
                   [legend]="legend"
                   (categorySelected)="onCategorySelected($event)">
      </app-pyramid>
    </div>

    <div class="td-flip-face td-flip-back">
      <app-score-development *ngIf="hasFlipped"
                             [scores]="teamScores"
                             [comparisonScores]="workspaceScores"
                             [comparisonTitle]="'td_team_report_workspace' | translate"
                             [chips]="scoreChips"
                             [activeChipUuid]="activeChipUuid"
                             [loading]="loadingScores"
                             (chipSelected)="onChipSelected($event)">
      </app-score-development>
    </div>
  </div>

  <div class="td-flip-switch">
    <button type="button" class="td-flip-switch-btn" [ngClass]="{'active': view === 'all'}"
            (click)="setView('all')">
      {{ 'td_team_report_overview' | translate }}
    </button>
    <button type="button" class="td-flip-switch-btn" [ngClass]="{'active': view === 'development'}"
            (click)="setView('development')">
      {{ 'td_team_report_development' | translate }}
    </button>
  </div>
</div>
